/* ========================================================================
//	MODULE - TOOLS
======================================================================== */

// GLOBAL
var
target = window.location.hash,
targetObj = new Object(),
scrollPg,
myEvt;

var MyTools = MyTools || {};
MyTools = (function ($,twM) {
	
	// BEFORE ANYTHING, GET HASH
	if(target != '#' && target != '' && target != '#_=_'){
		
		// NÃO ANCORA POR TABS
		if(target.indexOf('#tabs_') == -1){
			// ANCHOR
			target = target+'_hash';
		}
		else {
			// #tabs_foo-1_bar-1
			// ARRAY FOR TABS
			var myArr = target.split('#tabs_')[1].split('_');
			
			// console.log('myArr');
			// console.log(myArr);
			
			for (var i = 0; i < myArr.length; i++) {
				var
				label = myArr[i].split('-')[0],
				value = myArr[i].split('-')[1];
				targetObj[String(myArr[i].split('-')[0])] = String(myArr[i].split('-')[1]);
				
				// SETS SCROLL TARGET TO TABS
				if(i === myArr.length -1){
					// target = $('.'+label)[0];
					target = $('.'+label);
					// console.log('LABEL:'); console.log(label);
					// console.log('VALUE:'); console.log(value);
					// console.log('TARGET:'); console.log(target);
				}
			}
		}
		
	 }
	else { target = null; }
	
	
// BASE DOM
//	-----------------------------------------------------------------

	var
		$win = $(window),
		$doc = $(document),
		$html = $('html'),
			$body = $('body'),
				$pgSize = $('#pgSize'),
					$header = $('#header'),
					headerH,
					$pgContents = $('#pgContents'),
					// $footer = $('#footer'),
	
	
	
	
//	CHECK PLATFORM
//	-----------------------------------------------------------------
	
	deviceType = null, deviceOS = null, isMac = null, ieVersion = -1,
	// myEvt = null,
	checkPlatform = function(_args){

		// http://stackoverflow.com/questions/12606245/detect-if-browser-is-running-on-an-android-or-ios-device
		var isMobile = {
		    Android: function() { return /Android/i.test(navigator.userAgent); },
		    BlackBerry: function() { return /BlackBerry/i.test(navigator.userAgent); },
		    iOS: function() { return /iPhone|iPad|iPod/i.test(navigator.userAgent); },
		    Windows: function() { return /IEMobile/i.test(navigator.userAgent); },
		    any: function() { return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Windows()); }
		};

		// MOBILE
		if(isMobile.any()){

			// DEVICE TYPE
			deviceType = 'mobile';

			// DEVICE OS
			if(isMobile.Android()){ deviceOS = 'android'; }
			else if(isMobile.BlackBerry()){ deviceOS = 'blackberry'; }
			else if(isMobile.iOS()){ deviceOS = 'ios'; }
			else if(isMobile.Windows()){ deviceOS = 'ieMobile'; }
		}

		// DESKTOP
		else {

			// DEVICE TYPE
			deviceType = 'desktop';

			// DETECT IF IE
				// http://msdn.microsoft.com/en-us/library/ms537509%28v=vs.85%29.aspx
				// Returns the version of Internet Explorer or a -1 indicating the use of another browser
				ieVersion = -1;
				if (navigator.appName == 'Microsoft Internet Explorer'){
					var ua = navigator.userAgent;
					var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
					if (re.exec(ua) != null){ ieVersion = parseFloat( RegExp.$1 ); }
				}
				// DETECT IE11
				else if (navigator.appName == 'Netscape') {
				    var ua = navigator.userAgent;
				    var re  = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
				    if (re.exec(ua) != null){ ieVersion = parseFloat( RegExp.$1 ); }
				}

			// DEVICE OS
			if(ieVersion == -1) { deviceOS = 'modern'; } // ALL DESKTOP BROWSERS EXCEPT IE
			else {

				// COMPATIBILITY - Javascript Support Array.indexOf in IE
				if (!Array.indexOf) {
				  Array.prototype.indexOf = function (obj, start) {
				    for (var i = (start || 0); i < this.length; i++) { if (this[i] == obj) { return i; } }
				    return -1;
				  }
				}

				deviceOS = 'ie';
				// $('html').addClass(deviceOS+ieVersion);
			}
			
			// MAC OR PC
			if (navigator.userAgent.indexOf('Mac OS X') != -1) {
				isMac = true;// MAC
			} else {
				isMac = false;// PC
			}
		}
		
		
		myEvt = deviceType == 'desktop' ? 'click' : 'touchstart';
		
		$('html').addClass(deviceType);
		$('html').addClass(deviceOS);
		if(isMac) { $('html').addClass('mac'); }

		// console.log(
		// 	'\n/ commtrol / PLATFORM'+
		// 	'\n    deviceType: '+deviceType+
		// 	'\n    deviceOS: '+deviceOS+
		// 	'\n    ieVersion: '+ieVersion+
		// 	'\n    isMac: '+isMac
		// );
	},
	getPlatform = function(){
		return {
			deviceType: deviceType,
			deviceOS: deviceOS,
			isMac: isMac,
			ieVersion: ieVersion,
			myEvt: myEvt
		};
	},
	
	
	
	
//	MANAGE ON WIN RESIZE FUNCTIONS
//	-----------------------------------------------------------------
	
	/* EXAMPLE:
		MyTools.onWinResize({func: function(_args){
			console.log(_args);
		}});
	*/
	
	resizeFunctions = [],
	resizeFunc = function(_args){
		
		// console.log('\n/ commtrol / RESIZE');
		
		var
		resizeTimeout = null,
		winResize = function(){
			
			clearTimeout(resizeTimeout);

			var
			winW = Number($win.width()),
			winH = Number($win.height()),
			winRatio = winW / winH,
			winWStep = null,
			winStepNum = null,
			winStepMinVal = null,
			winStepMaxVal = null;
			
			if(winW > 1280){ winWStep = 'width-xl'; winStepNum = 5; winStepMinVal = 1281; winStepMaxVal = null; }
			else {
				if(winW > 1024){ winWStep = 'width-lg'; winStepNum = 4; winStepMinVal = 1025; winStepMaxVal = 1280; }
				else {
					if(winW > 768){ winWStep = 'width-md'; winStepNum = 3; winStepMinVal = 769; winStepMaxVal = 1024; }
					else {
						if(winW > 568){ winWStep = 'width-sm'; winStepNum = 2; winStepMinVal = 569; winStepMaxVal = 768; }
						else { winWStep = 'width-xs'; winStepNum = 1; winStepMinVal = 0; winStepMaxVal = 568; }
					}
				}
			}

			$('#pgSize').attr({
				'data-step': winWStep,
				'data-num': winStepNum
			});

			// TRIGGER ALL REGISTERED RESIZE FUNCTIONS
			var triggerRegisteredFunctions = function(){

				headerH = $header.outerHeight();
				
				for (var i = 0, j = resizeFunctions.length; i < j; i++) {
					if(resizeFunctions[i]){
						resizeFunctions[i].func({
							winW:winW,
							winH:winH,
							winRatio:winRatio,
							winWStep: winWStep,
							winStepNum: winStepNum,
							winStepMinVal: winStepMinVal,
							winStepMaxVal: winStepMaxVal,
							args: resizeFunctions[i].args
						});
					}
				};
			};
			triggerRegisteredFunctions();
			
			resizeTimeout = setTimeout(triggerRegisteredFunctions,100);
		};

		// ADD / TRIGGER RESIZE
		$win.resize(winResize).trigger('resize');
	},
	resizeRegisterFunction = function(_args){
		
		if(_args.pos){
			// REPLACE RESIZE FUNCTION
			// console.log('REPLACED AT: '+(_args.pos - 1));
			resizeFunctions[_args.pos - 1] = { func: _args.func, args: _args.args };
		}
		else {
			// ADD RESIZE FUNCTION
			// console.log('ADDED');
			resizeFunctions.push({ func: _args.func, args: _args.args });
		}
		
		// TRIGGER RESIZE
		$win.trigger('resize');
		
		// console.log(resizeFunctions);
		
		// RETURNS LENGTH OF RESIZE FUNCTIONS ARRAY
		// IS ALSO THE INDEX OF THE REGISTERED FUNCTION (WHEN NOT PASSED _ARGS.POS)
		return resizeFunctions.length;
	},
	resizeDestroy = function(_pos){
		// REMOVES FUNCTION FROM ARRAY, WITH POS
		resizeFunctions[_pos -1] = null;
		
		// console.log('DESTROYED:');
		// console.log(resizeFunctions);
	},
	
	
	
	
//	MANAGE ON SCROLL PER ELEMENT
//	-----------------------------------------------------------------
	
	/* EXAMPLES:
		
		MyTools.scrollMe({ view: $win, func: onPgScroll });
		
		MyTools.scrollMe({
			view: $win,
			func: onPgScroll,
			track: [
					{
					el: $('.teste'),
					full: true,
					inView: function(){ $('.teste').css('background','green'); },
					offView: function(){ $('.teste').css('background','red'); }
				}
			]
		});
		
	*/
	
	scrollFunc = function(_args){
		
		// console.log('\n/ commtrol / SCROLL');
		
		var
		myView = _args.view,
		isWindow = _args.view[0] === window;
		
		myView.on('scroll',function(e){
			
			var wTop = myView.scrollTop();
			var wLeft = myView.scrollLeft();
			
			_args.func({ wTop: wTop, wLeft: wLeft });
			
			/* TRACKING - OPTIONAL
			!!!! WORKS ONLY IF _ARGS.VIEW IS WINDOW !!!!
			----------------------------------------------------------------------
				Array of elements to be tracked if is in view when scrolled.
				By default, this function manages classes, according to elemnt status:
					- IN VIEW				(ADDS) 		.scroll-inview
					- OFF VIEW				(REMOVES) 	.scroll-inview
					
					(WHEN INVIEW / OFFVIEW FUNCTIONS REGISTERED)
					- IN VIEW TRIGGERED		(ADDS) 		.scroll-inViewTriggered
											(REMOVES) 	.scroll-offViewTriggered
					- OFF VIEW TRIGGERED	(ADDS) 		.scroll-offViewTriggered
											(REMOVES) 	.scroll-inViewTriggered	
				Arguments:
					el: 		(REQUIRED) element to track
					full: 		(OPTIONAL) boolean if element should be fully in view, or partially in view
					inView: 	(OPTIONAL) function triggered ONCE when el is inView
					offView: 	(OPTIONAL) function triggered ONCE when el is onView
				
				Usage: 
					MyTools.scrollMe({
						view: $win,
						func: onPgScroll,
						track: [
								{
								el: $('.teste'),
								full: true,
								inView: function(){ $('.teste').css('background','green'); },
								offView: function(){ $('.teste').css('background','red'); }
							}
						]
					})
			
			*/
			if(!_args.track || !isWindow) { return; }
			for (var i = 0, j = _args.track.length; i < j; i++) {
				var
				$el = _args.track[i].el,
				$full = _args.track[i].full,
				$inView = _args.track[i].inView,
				$offView = _args.track[i].offView,
				inViewTriggered = $el.hasClass('scroll-inViewTriggered'),
				offViewTriggered = $el.hasClass('scroll-offViewTriggered'),
				
				pageTop = myView.scrollTop(),
				pageBottom = pageTop + myView.outerHeight(),
				elementTop = $el.offset().top,
				elementBottom = elementTop + $el.outerHeight();
				
				// console.log($el);
				// console.log('elementTop',elementTop);
				// console.log('elementBottom',elementBottom);
				
				if ($full === true) {
					// return ((pageTop < elementTop) && (pageBottom > elementBottom));
					if((pageTop < elementTop) && (pageBottom > elementBottom)){
						$el.addClass('scroll-inview');
						if($inView && !inViewTriggered){ $inView(); $el.addClass('scroll-inViewTriggered'); }
						$el.removeClass('scroll-offViewTriggered');
					}
					else {
						$el.removeClass('scroll-inview');
						if($offView && !offViewTriggered){ $offView(); $el.addClass('scroll-offViewTriggered'); }
						$el.removeClass('scroll-inViewTriggered');
					}
				} else {
					// return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
					if((elementTop <= pageBottom) && (elementBottom >= pageTop)){
						$el.addClass('scroll-inview');
						if($inView && !inViewTriggered){ $inView(); $el.addClass('scroll-inViewTriggered'); }
						$el.removeClass('scroll-offViewTriggered');
					}
					else {
						$el.removeClass('scroll-inview');
						if($offView && !offViewTriggered){ $offView(); $el.addClass('scroll-offViewTriggered'); }
						$el.removeClass('scroll-inViewTriggered');
					}
				}
			}

		});

	},
	
	
	
	
//	MANAGE TOUCH
//	-----------------------------------------------------------------
	
	/* EXAMPLES: 
		
		MyTools.touch({
			el: $('*[data-btn]'),
			deactivate: 500,
			funcDelay: 500
		});
		
		MyTools.touch({
			el: $('*[data-btn]'),
			deactivate: 500,
			funcDelay: 500,
			func:function(){ alert('foo'); }
		});
		
	*/
	
	manageTouch = function(_args){

		// CONCEPT / USAGE:
		// ------------------------------------------
			// This function attempts to unify the experience of desktop/mobile and click/touch events

		// TODO:
		// ------------------------------------------
			// - Rewrite so _args receive multiple sets, instead of calling multiple times
			// - Improve touch move threshold for deactivation
			// - Test dismissable callback function to manage all deactivations


		// ARGUMENTS:
		// ------------------------------------------
			// el: (Required / Selector)

			// deactivate: (Optional / Number)
				// Defines how .active class is removed.
				// If not set, enables multiple .active elements
				// == 0: dactivates only on next .active selection
				// > 0: deactivates on timeout by value in miliseconds

			// func: (Optional)
				// function called after .active is set
				// If no func argument is present, it will search if element has href/target,
				// and use it to feed its default "goToLink" function.

			// funcDelay: (Optional - independent of func argument / Default: 0ms)
				// Delays function call so eventual .active animation can finish
				// If function is a window.open in _blank, delay will be ignored on desktop,
				// because of a behaviour inconsistency, it will call original href/target from html

			// dismissable: (Optional / Boolean / Default: false)
				// If true, click / touch start deactivates .active class

			// toggle: (Optional / Boolean / Default: false)
				// If true, toggles .active class


		// EXAMPLE CSS:
		// ------------------------------------------


		// EXAMPLE JS:
		// ------------------------------------------

			// myTools.touch({
			// 	el: $('[data-hover]'),
			//  deactivate: 0,
			// 	func: function
			// });

		
		var
		$btn = _args.el,

		deactivate = _args.deactivate,
		deactivateTo = null,

		func = _args.func,
		funcTo = null,
		funcDelay = typeof _args.funcDelay !== "undefined" ? _args.funcDelay : 0,

		dismissable = _args.dismissable,
		toggle = _args.toggle !== "undefined" ? _args.toggle : false,


		goToLink = function(_args){
			// ARGS:
			// _args.evt
			// _args.this
			// _args.link
			// _args.target

			_args.evt.preventDefault();


			if(_args.target != "_blank"){
				funcTo = setTimeout(function() {
					window.location = _args.link;
				},funcDelay);
			}
			else {
				var win = window.open(_args.link,'_blank');
				win.focus();
			}


		};

		$btn.addClass('manage-touch');


		if(deviceType == 'desktop'){

			if(dismissable){
				$win.on('click',function(e){
					$btn.removeClass('active');
				});
			}

			$btn.on('click',function(e){

				var
				$this = $(this),
				myIndex = $btn.index($this); // INDEX OF $THIS RELATIVE TO SELECTOR GROUP $BTN

				// FANCYBOX NEEDS PROPAGATION TO BE TRIGGERED
				if($this.attr('data-fancybox') === undefined){
					e.stopPropagation();
				}


				// DEACTIVATE
				if(typeof deactivate !== "undefined"){
					if(deactivate == 0){
						$btn.not($this).removeClass('active');
					}
					else {
						deactivateTo = setTimeout(function() {
							$this.removeClass('active');
						},deactivate);
					}
				}

				// TOGGLE / ADD CLASS ACTIVE
				if(toggle){ $this.toggleClass('active'); } else { $this.addClass('active'); }

				// FUNC
				clearTimeout(funcTo);

				if(func){
					if($this.attr('target') != '_blank'){ e.preventDefault(); }

					funcTo = setTimeout(function() {
						func({ evt: e, this: $this, index: myIndex, toggled: $this.hasClass('active')});

						// IF PREVENTDEFAULT FALSE, TRIGGER ORIGINAL HREF CALL
						if(_args.preventDefault == false){
							goToLink({evt: e, this: $this, link: $this.attr('href'), target: $this.attr('target')});
						}

					},funcDelay);
				}
				else if($this.attr('href')){
					if($this.attr('data-fancybox') !== undefined){
						// FANCYBOX SHOULDN'T ALL GOTOLINK
					}
					else {
						goToLink({evt: e, this: $this, link: $this.attr('href'), target: $this.attr('target')});
					}
				}
			});
		}

		else {
			var
			touchStartX,
			touchStartY,
			isTouching = false;


			if(dismissable){
				$win.on('touchstart',function(e){
					if(isTouching) return;
					$btn.removeClass('active').removeClass('hover');
				});
			}


			$btn.on('touchstart',function(e){

				isTouching = true;

				// console.log("[BTN] TOUCHSTART");

				// e.stopPropagation();
				// e.preventDefault();

				clearTimeout(funcTo);

				var
				$this = $(this),
				myIndex = $btn.index($this);

				touchStartX = e.originalEvent.changedTouches[0].clientX,
				touchStartY = e.originalEvent.changedTouches[0].clientY,

				$btn.removeClass('hover');
				$this.addClass('hover');
			});
			$btn.on('touchmove',function(e){

				var
				$this = $(this),
				myIndex = $btn.index($this),
				touchX = e.originalEvent.changedTouches[0].clientX,
				touchY = e.originalEvent.changedTouches[0].clientY,
				elOffsetX = $this.offset().left,
				elOffsetY = $this.offset().top,
				elWidth = $this.width(),
				elHeight = $this.height();

				if(
					touchX >= elOffsetX &&
					touchX <= elOffsetX+elWidth &&
					touchY >= elOffsetY &&
					touchY <= elOffsetY+elHeight &&
					Math.abs(touchStartY - touchY) < 10
				){
					// console.log("INSIDE");
				}
				else {
					// console.log("-----");
					$btn
					.removeClass('hover');
					// .removeClass('active');
					if(dismissable){ $btn.removeClass('active'); }
					else { $this.removeClass('active'); }
				}
			});
			$btn.on('touchend',function(e){
				isTouching = false;

				// console.log(e.target);
				// console.log(e.currentTarget);

				// PREVENTS NESTED BTN COLLISIONS AS LONG AS CHILD BTN IS ALSO REGISTERED TO TOUCH FUNCTION
				if( (e.target != e.currentTarget) && $(e.target).hasClass('manage-touch')){ return; }

				var
				$this = $(this),
				myIndex = $btn.index($this); // INDEX OF $THIS RELATIVE TO SELECTOR GROUP $BTN

				// PREVENT CLICK IF NOT FANCYBOX
				if($this.attr('data-fancybox') === undefined){
					$this.on('click',function(e){ e.preventDefault(); });
				}


				if($this.hasClass('hover')){
					$this.removeClass('hover');

					// DEACTIVATE
					if(typeof deactivate !== "undefined"){
						if(deactivate == 0){
							$btn.not($this).removeClass('active');
						}
						else {
							deactivateTo = setTimeout(function() {
								$this.removeClass('active');
							},deactivate);
						}
					}

					// TOGGLE / ADD CLASS ACTIVE
					if(toggle){ $this.toggleClass('active'); } else { $this.addClass('active'); }

					// FUNC
					clearTimeout(funcTo);

					if(func){

						funcTo = setTimeout(function() {

							func({ evt: e, this: $this, index: myIndex, toggled: $this.hasClass('active')});

							// IF PREVENTDEFAULT FALSE, TRIGGER ORIGINAL HREF CALL
							if(_args.preventDefault == false){
								goToLink({evt: e, this: $this, link: $this.attr('href'), target: $this.attr('target')});
							}

						},funcDelay);
					}
					else if($this.attr('href')){
						if($this.attr('data-fancybox') !== undefined){
							// FANCYBOX SHOULDN'T CALL GOTOLINK, SO DEFAULT BEHAVIOUR SHOULD HAPPEN
						}
						else {
							goToLink({evt: e, this: $this, link: $this.attr('href'), target: $this.attr('target')});
						}
					}





				}
			});
		}
	},
	
	
	
	
//	MANAGE ANIMATED SCROLL TO ANCHOR
//	-----------------------------------------------------------------
	
	// IMPORTANT: ANCHORS MUST BE SET WITH '_HASH' AT THE END
	
	// scrollPg = function(_customOffset){
	// 	if(target && $(target).length > 0){
	// 		var
	// 		anchorTop = $(target).offset().top,
	// 		contentTop = $pgContents.offset().top,
	// 		myScrollTop = Number(anchorTop - contentTop - headerH + (_customOffset ? _customOffset : 0));
	// 
	// 		// USE AUTOKILL: FALSE TO PREVENT IOS BUG
	// 		TweenLite.to(window, 1, { scrollTo:{ y: myScrollTop, autoKill: false }, ease:Power4.easeOut, onComplete: function(){
	// 			// RESET HASH, BUT DON'T SET TO EMPTY ('' or '#'), BECAUSE WILL CALL '#' ANCHOR, WHICH DEFAULTS TO SCROLLTOP(0).
	// 			window.location.hash = '#_';
	// 		} });
	// 	}
	// },
	hashChanged = function(){
		target = window.location.hash;
		if(target !== '#' && target !== '' && target !== '#_'){
			if(target.indexOf('#tabs_') == -1){
				target = target+'_hash';
				if($(target).length > 0){
					var targetTop = $(target).offset().top;
					scrollPg();
				}
			}
		}
		else { target = null; }
	},
	
	
	
	
//	ADD TOUCH CAPABILITY TO MENU WITH TOGGLE BTNS
//	-----------------------------------------------------------------
	
	onMenuToggle = function(_args){

		_args.evt.preventDefault();
		_args.evt.stopPropagation();
		
		
		/* */
        var
		$me = $(_args.evt.currentTarget),
		$myBot,
		$myA,
		$myLi,
		$myMenu,
		$allA;

		// LOCATE SUBTOGGLE BTN
		if($me.hasClass('subToggle')){ $myBot = $me; }
		else { $myBot = $me.children('.subToggle'); }

		$myA = $myBot.parent();
		$myLi = $myBot.parent().parent('li');
		
		var $mySubmenu = $myLi.children('.sub-menu-wrap');

		var $mySubmenuContent = $mySubmenu.children();
		
		// ALL SUBMENUS INSIDE
		// $mySubSubmenus = $myLi.find('.sub-menu-wrap');
		// $mySubSubmenusContent = $mySubSubmenus.children();
		
		// ALL PARENT SUBMENUS
		// $mySubmenuParents = $mySubmenu.parents('li');
		// $mySubmenuParentsA = $mySubmenuParents.children('a');
		// $mySubmenuParentsSub = $mySubmenuParents.children('.sub-menu-wrap');
		
		
		$myMenu = $myLi.parents('.menu');
		$allA = $myMenu.find('a');
		
		var willOpen = true;
		
		if($myLi.hasClass('active')){
			
			willOpen = false;
			
			// REMOVE LI ACTIVE
			$myLi.removeClass('active');
			
			// REMOVE LI ACTIVE FROM ALL CHILDREN
			$myLi.find('li').removeClass('active');
			
			// REMOVE ALL HOVER CLASS
			$allA.removeClass('hover');
			
			// SET HEIGHT
			$mySubmenu.height(0);
			$myLi.find('li').children('.sub-menu-wrap').height(0);
			
		}
		else {
			
			// REMOVE OTHERS LI ACTIVE
			$myMenu.find('li').not($myLi).not($myLi.parents()).removeClass('active');
			
			// ADD CURRENT LI ACTIVE
			$myLi.addClass('active');
			
			// REMOVE OTHERS HOVER CLASS
			$allA.not($myA).removeClass('hover');
			
			// CLOSE PREVIOUSLY OPEN SUB
			$myMenu.find('li').not($myLi).not($myLi.parents()).children('.sub-menu-wrap').height(0);
			
			// OPEN SELECTED SUBMENU
			$mySubmenu.height($mySubmenuContent.outerHeight());
			
		}
		
		
		
		
		// RESPONDER ALTURA DOS SUBS PARENTS
		var
		$mySubParents = $mySubmenu.parents('.sub-menu-wrap');
		// console.log($mySubParents);
		
		$mySubParents.each(function(i) {
			
			// console.log(i);
			var
			$this = $(this),
			$myBtns = $this.children().children(),
			myBtnsHeight = 0;
			
			// console.log($myBtns);
			
			for (var i = 0; i < $myBtns.length; i++) {
				myBtnsHeight += $($myBtns[i]).children('a').outerHeight();
			}
			// console.log('myBtnsHeight',myBtnsHeight);
			// console.log('$mySubmenuContent',$mySubmenuContent.outerHeight());
			
			if(willOpen){
				$this.height(myBtnsHeight + $mySubmenuContent.outerHeight());
			}
			else {
				$this.height(myBtnsHeight);
			}
			
		});
		
		
		/* * /
		setTimeout(function(){
			console.log($myLi.position().top);
			// console.log($myLi.parent().position().top);
			var liY = $myLi.parent().position().top + $myLi.position().top;
			// ATTEMPT TO AIM SCROLL
			TweenLite.to($('#menuHeaderContainer'), 1, { scrollTo:{ y: liY, autoKill: false }, ease:Power4.easeOut, onComplete: function(){
				// RESET HASH, BUT DON'T SET TO EMPTY ('' or '#'), BECAUSE WILL CALL '#' ANCHOR, WHICH DEFAULTS TO SCROLLTOP(0).
				// window.location.hash = '#_';
			} });
		},500);
		/* */
		
		
		
		// IF YOU WANT TO ATTACH A FUNCTION TO BE TRIGGERED ON EACH SUBTOGGLE
		// if(_args.args.func){ _args.args.func({ evt: _args.evt}); }

	},
	menuArrows = function(_args){
		
		// ARGS:
		// _args.el             (REQUIRED) The menu (ul.menu) element
        // _args.dismissable    (OPTIONAL) Boolean / Number
        
		// DISMISSABLE
        if(_args.dismissable){

            _args.el.addClass('dismissable');
            $body.on(myEvt, function(e){
                if(!$(e.target).parents('.menu').length){

					if (typeof _args.dismissable == 'number'){
						if($pgSize.attr('data-num') >= _args.dismissable){
							$('.menu.dismissable').find('.active').removeClass('active');
						}
					}
					else {
						$('.menu.dismissable').find('.active').removeClass('active');
					}
                }
			});
			

        }

		var
		$myMenu = _args.el,
		$myA = $myMenu.find('a');

		$myA.each(function(e){

			var $this = $(this);

			// IF HAS SUBMENU, ADD SUBTOGGLE BUTTON
			if($this.siblings().length > 0){
				$this.append("<div class='subToggle'></div>");

				// IF <A> HAS NO LINK, APPLY SUBTOGGLE FUNCTION TO IT
				if(	$this.attr('href') === "javascript:void(0)" ||
				$this.attr('href') === "#" ||
				$this.attr('href') === "" ||
				$this.attr('href') === undefined){
					manageTouch({ el: $this, deactivate: 500, func: onMenuToggle });
				}
				// ELSE
				else {
					manageTouch({ el: $this, deactivate: 500, funcDelay: 500 });
				}
			}
			else {
				manageTouch({ el: $this, deactivate: 500, funcDelay: 500 });
			}
		});

		var $subToggle = $myMenu.find('.subToggle');
		
		manageTouch({ el: $subToggle, deactivate: 500,  funcDelay: 250, func: subToggleFunc });
		function subToggleFunc(__args){
			onMenuToggle( { evt: __args.evt, args: _args });
		}
		
	},
	
	/* * /
	accordionToggle = function (_args) {
		console.log('ACCORDION TOGGLE');
		var
		// $btn = _args.btn,
		// $parent = _args.parent,
		$content = _args.content,
		$allContents = _args.allContents;
		
		for (var i = 0; i < $allContents.length; i++) {
			if($allContents[i] !== $content){
				$allContents[i].classList.remove('active')
				$allContents[i].setAttribute("style","height:0")
			} else {
				$content.classList.toggle("active")
				if($content.classList.contains('active')){
					$allContents[i].setAttribute("style","height:"+this.itemsH[i]+"px")
				} else {
					$allContents[i].setAttribute("style","height:0")
				}
			}
		}
	},
	
	accordionOnResize = function(_args){
		console.log('ACCORDION RESIZE');
		
		// console.log(_args.args);
		
		var itemsH = [];
		var $allContents = _args.args.allContents;
		console.log($allContents.length);
		
		for (var i = 0; i < $allContents.length; i++) {
			
			var contentH = $allContents[i].children().first().outerHeight();
			if($allContents[i].classList.contains('active')){
				$allContents[i].setAttribute("style","height:"+contentH+"px")
			}
			// console.log(itemContent[0])
			itemsH.push(contentH)
			
		}
	},
	
	
	accordionInit = function(_args){
		
		var
		// $btn = _args.el,
		// $parent = _args.el.parent().parent(),
		// $content = _args.el.parent().siblings('.sub-menu-wrap'),
		// $allContents = _args.el.parent().parent().find('.sub-menu-wrap');
		$btn = _args.btn,
		$parent = _args.parent,
		$content = _args.content,
		$allContents = _args.allContents;
		
		$btn.on(myEvt,function(){
			accordionToggle(_args);
		});
		
		resizeRegisterFunction({func: accordionOnResize, args: _args });
		
	},
	/* */
	
	
//	INIT PAGE
//	-----------------------------------------------------------------

	initPg = function(_pgName){
		setTimeout(function(){
			
			$win.trigger('resize');
			$body.addClass('loaded');
			$pgSize.css({ 'opacity':1 });
			
			scrollPg();
			
			console.log('\n/ commtrol / '+_pgName.toUpperCase());

		},300);
	},
	
	
	
	
//	INIT
//	-----------------------------------------------------------------

	init = function(){
		
		// console.log('\n/ commtrol / INIT');
		
		// CHECK PLATFORM
		checkPlatform();
		
		// INIT WIN RESIZE MANAGEMENT
		resizeFunc();
		
		// LISTEN TO HASH CHANGE (ANIMATED SCROLL TO ANCHORS)
		window.onhashchange = hashChanged;
		
		// INITPG SHOULD BE CALLED AT THE END OF EACH PAGE SPECIFIC JS
		// initPg();
		
		
		//	CLEAN WP EDITOR <P> MESS - CHECK IF STILL NEEDED
		// $('p').each(function(){
		// 	var $p = $(this);
		// 	if($p.html() == ""){ $p.remove(); }
		// })
		
	};
	
	init();
	
	
	// scrollPg = function(_customOffset){
	scrollPg = function(_args){
		if(typeof(_args) == "undefined"){
			// console.log('SCROLLPG!');
			if(target && $(target).length > 0){
				// console.log('INSIDE!');
				var
				anchorTop = $(target).offset().top,
				contentTop = $pgContents.offset().top,
				// myScrollTop = Number(anchorTop - contentTop - headerH + (_customOffset ? _customOffset : 0));
				myScrollTop = Number(anchorTop - contentTop - headerH);
				
				// console.log('TARGET');
				// console.log($(target));
				// console.log('ANCHOR TOP');
				// console.log(anchorTop);
				
				
				// USE AUTOKILL: FALSE TO PREVENT IOS BUG
				TweenLite.to(window, 1, { scrollTo:{ y: myScrollTop, autoKill: false }, ease:Power4.easeOut, onComplete: function(){
					// RESET HASH, BUT DON'T SET TO EMPTY ('' or '#'), BECAUSE WILL CALL '#' ANCHOR, WHICH DEFAULTS TO SCROLLTOP(0).
					window.location.hash = '#_';
				} });
			}
		}
		else {
			if(typeof(_args.el) !== "undefined"){
				var
				anchorTop = $(_args.el).offset().top,
				contentTop = $pgContents.offset().top,
				customOffset = typeof(_args.offset) == "undefined" ? 0 : _args.offset,
				// myScrollTop = Number(anchorTop - contentTop - headerH + (_customOffset ? _customOffset : 0));
				myScrollTop = Number(anchorTop - contentTop - headerH + customOffset);
				
				// USE AUTOKILL: FALSE TO PREVENT IOS BUG
				// TweenLite.to(window, 1, { scrollTo:{ y: myScrollTop, autoKill: false }, ease:Power4.easeOut });
				TweenLite.to(window, 1, { scrollTo:{ y: myScrollTop, autoKill: false }, ease:Power4.easeOut, onComplete: function(){
					// RESET HASH, BUT DON'T SET TO EMPTY ('' or '#'), BECAUSE WILL CALL '#' ANCHOR, WHICH DEFAULTS TO SCROLLTOP(0).
					window.location.hash = '#_';
				} });
			}
		}
	}
	
	

//	RETURNS
//	-----------------------------------------------------------------

	return {
		
		// GET PLATFORM INFO
		platform: getPlatform,
		
		// ON WINDOWS RESIZE
		onWinResize: resizeRegisterFunction,
		resizeDestroy: resizeDestroy,
		
		// ON ELEMENT SCROLL
		scrollMe: scrollFunc,
		
		// ON TOUCH
		touch: manageTouch,
		
		// MENU TOGGLE ARROWS
		menuArrows: menuArrows,
		
		// INIT PG
		initPg: initPg,
		
	};



})(jQuery);

